/**
 * Tech Department navigation items.
 * Used by App.js for sidebar/rail navigation and permission-based filtering.
 */
const techNavigation = [
  { path: '/cto-dashboard', label: 'CTO Dashboard', module: 'CTO Dashboard' },
  { path: '/employee-management', label: 'Employee Management', module: 'Employee Management' },
  { path: '/visitor-analytics', label: '🌐 Visitor Analytics', module: 'Visitor Analytics' },
];

export default techNavigation;
